import React from "react";

export const EnglishIcon: React.SFC<{ active?: boolean }> = ({
  active = false,
  ...props
}) => (
  <svg viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M50 25c0 13.806-11.194 25-25 25C11.193 50 0 38.807 0 25S11.193 0 25 0s25 11.193 25 25z"
      fill="#F0F0F0"
    />
    <path
      d="M5.168 9.78a24.892 24.892 0 00-4.306 8.698h13.005L5.168 9.779zM49.138 18.479a24.89 24.89 0 00-4.306-8.699l-8.7 8.699h13.006zM.86 31.522a24.933 24.933 0 004.307 8.699l8.7-8.699H.86zM40.221 5.168A24.913 24.913 0 0031.523.862v13.005l8.698-8.699zM9.78 44.831a24.89 24.89 0 008.698 4.307V36.133L9.779 44.83zM18.478.86a24.934 24.934 0 00-8.699 4.307l8.699 8.699V.861zM31.523 49.138a24.89 24.89 0 008.698-4.306l-8.698-8.7v13.006zM36.133 31.522l8.698 8.699a24.912 24.912 0 004.307-8.699H36.133z"
      fill="#0052B4"
    />
    <path
      d="M49.789 21.74H28.26V.21a25.207 25.207 0 00-6.522 0v21.527H.211a25.24 25.24 0 000 6.523h21.527v21.528a25.217 25.217 0 006.523 0V28.26h21.528a25.2 25.2 0 000-6.52z"
      fill="#D80027"
    />
    <path
      d="M31.523 31.522l11.155 11.156a24.733 24.733 0 001.47-1.605l-9.55-9.55h-3.075zM18.478 31.522L7.322 42.678a24.72 24.72 0 001.605 1.47l9.55-9.55v-3.076zM18.478 18.479L7.322 7.322a25.077 25.077 0 00-1.47 1.605l9.55 9.55h3.076v.002zM31.523 18.479L42.678 7.323a25.065 25.065 0 00-1.605-1.47l-9.55 9.552v3.074z"
      fill="#D80027"
    />
    <circle cx={25} cy={25} r={23} stroke="#000" strokeWidth={4} />
    {active && <circle cx={25} cy={25} r={19} stroke="#fff" strokeWidth={4} />}
  </svg>
);
